// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___Oxw8g","digit":"style__digit___1TPcK","dot":"style__dot___xWBqC"};


//////////////////
// WEBPACK FOOTER
// ./components/CPDTime/style.scss
// module id = 1147
// module chunks = 0